import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
        this.banner = this.el; // L'élément ciblé est accessible via `this.el` dans stereomodularjs
        this.spyElement = document.querySelector('.js-spy-banner-bottom'); // L'élément à observer
        this.closeButton = this.banner.querySelector('.js-banner-bottom-close'); // Bouton de fermeture
        this.cookieName = 'bannerBottomClosed'; // Nom du cookie
    }

    init() {
        if (!this.banner || !this.spyElement) return; // Si les éléments n'existent pas, on arrête l'exécution

        // Vérifie si le cookie existe
        if (this.getCookie(this.cookieName)) {
            this.applyClosedState();
            return; // Si le cookie est actif, on arrête l'exécution
        }

        // Initialise l'IntersectionObserver
        this.initObserver();

        // Ajoute un écouteur pour le bouton de fermeture
        this.initCloseButton();
    }

    initObserver() {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) {
                        // L'élément a quitté le viewport
                        this.activateBanner();
                        // console.log('BannerBottom: Banner activated');
                    } else {
                        // L'élément est revenu dans le viewport
                        this.deactivateBanner();
                        // console.log('BannerBottom: Banner desactivated');
                    }
                });
            },
            {
                root: null, // Utilise le viewport comme référence
                threshold: 0.9, // Déclenche dès que l'élément quitte ou entre dans le viewport
            }
        );

        // Observe l'élément
        observer.observe(this.spyElement);
    }

    initCloseButton() {
        if (!this.closeButton) return; // Si le bouton n'existe pas, on arrête l'exécution

        this.closeButton.addEventListener('click', () => {
            // Ajoute la classe sur <html>
            this.applyClosedState();

            // Définit un cookie pour 7 jours
            this.setCookie(this.cookieName, 'true', 7);
            console.log('BannerBottom: Banner closed and cookie set for 7 days');

            // Définit un cookie pour 1 minute
            // this.setCookie(this.cookieName, 'true', 1);
            // console.log('BannerBottom: Banner closed and cookie set for 1 minute');
            
        });
    }

    activateBanner() {
        // Ajoute la classe -is-banner-active
        this.banner.classList.add('-is-banner-active');

        // Change aria-hidden="true" en aria-hidden="false"
        this.banner.setAttribute('aria-hidden', 'false');
    }

    deactivateBanner() {
        
        // Retire la classe -is-banner-active
        this.banner.classList.remove('-is-banner-active');

        // Change aria-hidden="false" en aria-hidden="true"
        this.banner.setAttribute('aria-hidden', 'true');
    }

    applyClosedState() {

        // Retire le focus du bouton de fermeture
        if (this.closeButton) {
            this.closeButton.blur(); // Retire le focus du bouton
        }
        
        // Ajoute la classe -has-banner-bottom-closed sur <html>
        document.documentElement.classList.add('-has-banner-bottom-closed');

        // Cache la bannière
        this.banner.setAttribute('aria-hidden', 'true');
        this.banner.classList.remove('-is-banner-active');
    }
    // set cookie for days
    setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000); // Définit l'expiration en jours
        document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
    }

    // set cookie for minutes
    // setCookie(name, value, minutes) {
    //     const date = new Date();
    //     date.setTime(date.getTime() + minutes * 60 * 1000); // Définit l'expiration en minutes
    //     document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
    // }

    getCookie(name) {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.startsWith(`${name}=`)) {
                return cookie.substring(name.length + 1);
            }
        }
        return null;
    }
}
